import React, {FC} from 'react';
import useTheme from 'evcharging/hooks/useTheme';
import useI18n from 'evcharging/hooks/useI18n';
import {Theme} from 'evcharging/app/themes';
import {css} from '@emotion/css';
import clsx from 'clsx';
import {E5Service} from 'evcharging/services/types';
import Paragraph from 'evcharging/components/Paragraph';
import Spacer from 'evcharging/components/Spacer';
import LinkButton from 'evcharging/components/LinkButton';
import Desktop from "../../evcharging/components/Desktop";
import Mobile from "../../evcharging/components/Mobile";

interface OfferItemProps {
  service: E5Service;
  open: boolean;
  onToggle: () => void;
}

const OfferItem: FC<OfferItemProps> = (props) => {
  const {service, open, onToggle} = props;
  const theme = useTheme();
  const styles = createStyles(theme);
  const {t} = useI18n();

  return (
    <>
      <Desktop>
        <button onClick={onToggle} className={clsx(styles.root, open ? styles.active : styles.inactive)}>
          <div>{service.name}</div>
          {open && (<section style={{backgroundImage: `url(${service.bgImage})`}}>
            <div className={styles.title}>
              <div>{service.name}</div>
              {/*<button className={styles.button} onClick={onToggle}>*/}
              {/*  <DropDownIcon className={clsx(styles.arrow, styles.arrowWhite, open && styles.rotate)} />*/}
              {/*</button>*/}
            </div>
            <Spacer value={12}/>
            <Paragraph size={'small'} color={'light'}>
              {service.description}
            </Paragraph>
            <div style={{marginTop: 'auto'}}>
              <LinkButton href={service.url}>Explore</LinkButton>
            </div>
          </section>)}
          {!open &&
            <svg className={clsx(styles.arrow, open && styles.rotate)} xmlns="http://www.w3.org/2000/svg" width="7"
                 height="12" viewBox="0 0 7 12" fill="none">
              <path
                d="M1.00016 11.7333C0.822385 11.7333 0.666829 11.6724 0.533496 11.5507C0.400162 11.4289 0.333496 11.2676 0.333496 11.0667V0.933329C0.333496 0.733329 0.400162 0.57244 0.533496 0.450663C0.666829 0.328885 0.822385 0.267551 1.00016 0.266663C1.04461 0.266663 1.20016 0.333329 1.46683 0.466663L6.30016 5.3C6.41127 5.41111 6.48905 5.52222 6.5335 5.63333C6.57794 5.74444 6.60016 5.86666 6.60016 6C6.60016 6.13333 6.57794 6.25555 6.5335 6.36666C6.48905 6.47777 6.41127 6.58888 6.30016 6.7L1.46683 11.5333C1.40016 11.6 1.32816 11.6502 1.25083 11.684C1.1735 11.7178 1.08994 11.7342 1.00016 11.7333Z"
                fill="#333333"/>
            </svg>
          }
          {open && (
            <section style={{backgroundImage: `url(${service.bgImage})`}}>
              <div className={styles.title}>
                <div>{service.name}</div>
              </div>
              <Spacer value={12}/>
              <Paragraph size={'x-small'} color={'light'}>
                {service.description}
              </Paragraph>
              <div style={{marginTop: 15}}>
                <LinkButton href={service.url}>Explore</LinkButton>
              </div>
            </section>
          )}
        </button>
      </Desktop>


      <Mobile>
        <button onClick={onToggle} className={clsx(styles.root, open ? styles.active : styles.inactive)}>
          <div className={clsx(styles.name, open ? styles.activeMob : styles.inactive)} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>{service.name}</div>
            {!open && (
              <svg className={clsx(styles.arrow, open && styles.rotate)} style={{overflow: 'visible'}} xmlns="http://www.w3.org/2000/svg" width="7"
                   height="12" viewBox="0 0 7 12" fill="none">
                <path
                  d="M1.00016 11.7333C0.822385 11.7333 0.666829 11.6724 0.533496 11.5507C0.400162 11.4289 0.333496 11.2676 0.333496 11.0667V0.933329C0.333496 0.733329 0.400162 0.57244 0.533496 0.450663C0.666829 0.328885 0.822385 0.267551 1.00016 0.266663C1.04461 0.266663 1.20016 0.333329 1.46683 0.466663L6.30016 5.3C6.41127 5.41111 6.48905 5.52222 6.5335 5.63333C6.57794 5.74444 6.60016 5.86666 6.60016 6C6.60016 6.13333 6.57794 6.25555 6.5335 6.36666C6.48905 6.47777 6.41127 6.58888 6.30016 6.7L1.46683 11.5333C1.40016 11.6 1.32816 11.6502 1.25083 11.684C1.1735 11.7178 1.08994 11.7342 1.00016 11.7333Z"
                  fill="#333333"/>
              </svg>
            )}
          </div>
          <div className={styles.mobileOnly}>
            {open && (
              <div className={styles.mobileSection} style={{backgroundImage: `url(${service.bgImage})`}}>
                <div className={styles.title}>
                  <div>{service.name}</div>
                </div>
                <Spacer value={12}/>
                <Paragraph size={'small'} color={'light'}>
                  {service.description}
                </Paragraph>
                <div style={{marginTop: 25}}>
                  <LinkButton href={service.url}>Explore</LinkButton>
                </div>
              </div>
            )}
          </div>
        </button>
      </Mobile>

    </>
  );
};

const createStyles = (theme: Theme) => ({
  root: css`
      display: flex;
      height: 68px;
      width: 100%;
      justify-content: space-between;
      align-items: center;
      background-color: #F6F8F9;
      border-radius: 6px;
      margin-top: 24px;
      padding: 0 32px;
      color: #303940;
      font-weight: 700;
      font-size: 24px;
      border: none;
      outline: none;
      cursor: pointer;
      text-align: left;

      ${theme.breakpoints.mobile.down} {
          flex-direction: column;
          align-items: flex-start;
          font-size: 18px;
          height: auto;
          padding: 0;
          background-color: white;
      }

      section {
          position: absolute;
          top: 25px !important;
          left: 105%;
          height: 344px;
          width: 95%;
          z-index: 10;
          border-radius: 6px;
          background-position: center;
          background-size: cover;
          background-repeat: no-repeat;
          padding: 24px;
          display: flex;
          flex-direction: column;
      }


      :last-child {
          section {
              top: unset;
              bottom: 0;
          }
      }

      :nth-last-child(2) {
          section {
              top: unset;
              bottom: 0;
          }
      }
  `,
  mobileOnly: css`
      width: 100%;
  `,
  mobileSection: css`
      margin-top: 16px;
      width: 100%;
      border-radius: 6px;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
      padding: 24px;
      display: flex;
      flex-direction: column;
      color: white;
  `,
  active: css`
      border: 2px solid #333333;

      ${theme.breakpoints.mobile.down} {
          border: none !important;
      }
  `,
  activeMob: css`
      border: 2px solid #333333;
  `,
  inactive: css`
      background-color: #F6F8F9;
      min-width: 100%;
  `,
  name: css`
      position: relative;
      min-width: 100%;
      background-color: #F6F8F9;
      padding: 16px;
      border-radius: 6px;
  `,
  button: css`
      background: none;
      border: none;
      outline: none;
      cursor: pointer;
  `,
  title: css`
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #F9C106;
      font-weight: 700;
      font-size: 24px;
      line-height: 36px;
  `,
  arrow: css`
      transition: all 200ms;
  `,
  arrowWhite: css`
      fill: #F6F8F9;
  `,
  rotate: css`
      transform: rotate(-90deg);
  `
});

export default OfferItem;
